import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const ArrowLeft: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.7004 4.90097C13.1965 4.40391 14.0021 4.40461 14.4973 4.90252C14.9902 5.39804 14.9893 6.1989 14.4953 6.69333L9.1897 12.004L14.4942 17.3067C14.9887 17.801 14.9898 18.6023 14.4968 19.098C14.0018 19.5957 13.1966 19.5966 12.7004 19.1L6.23845 12.6319C5.89183 12.285 5.8917 11.7228 6.23814 11.3757L12.7004 4.90097Z"
      fill="currentColor"
    />
  </svg>
);
